import images from "../../../images";
import { cn } from "../../../Utils/helper";

export function MetricCardRetention({
  label,
  value,
  classNameLabel,
  classNameValue,
  opacity,
  status,
  unit,
  unit_position,
}) {
  const isLocked = status === "lock";

  return (
    <article
      className={cn(
        "p-3 mb-3 bg-white rounded-lg border border-solid border-stone-200 max-sm:mb-2",
        isLocked ? "opacity-50 pointer-events-none select-none" : ""
      )}
      style={{ opacity: isLocked ? 0.5 : opacity / 100 }} // Apply base opacity or 50% when locked
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center flex-row justify-between w-full">
          <h3
            className={cn(
              "text-lg font-bold text-neutral-500",
              classNameLabel,
              isLocked ? "text-gray-400" : ""
            )}
          >
            {label}
          </h3>
          {isLocked ? (
            <img
              src={images.LockIcon}
              className="w-[24px] opacity-70"
              alt="Locked"
            />
          ) : (
            <span
              className={cn(
                "px-2 py-0.5 text-sm font-medium text-center bg-amber-200 rounded-md text-zinc-800",
                classNameValue
              )}
            >
              {unit && unit_position === "before" && <span>{unit} </span>}
              {value}
              {unit && unit_position === "after" && <span> {unit}</span>}
            </span>
          )}
        </div>
      </div>
    </article>
  );
}
